import { render, staticRenderFns } from "./SeriesCollectionDetails.vue?vue&type=template&id=f50412aa&scoped=true"
import script from "./SeriesCollectionDetails.vue?vue&type=script&lang=js"
export * from "./SeriesCollectionDetails.vue?vue&type=script&lang=js"
import style0 from "./SeriesCollectionDetails.vue?vue&type=style&index=0&id=f50412aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50412aa",
  null
  
)

export default component.exports